import { mockDB } from './../db/index';
import { API_PATH } from '@api/path/path';
import { createHandler, sleep } from '../utils';

export const getPointInfo = () =>
  createHandler(
    API_PATH.PointToken.findUserIssuedPointToken,
    async (req, res, ctx) => {
      await sleep(200);
      return res(ctx.status(200), ctx.json(mockDB.point.pointInfo.get()));
    },
  );

export const updatePointInfo = () =>
  createHandler(
    API_PATH.PointToken.updatePointTokenSymbol,
    async (req, res, ctx) => {
      await sleep(200);
      return res(
        ctx.status(200),
        ctx.json({ id: mockDB.point.pointInfo.get().id }),
      );
    },
  );

export const getPointInvocies = () =>
  createHandler(
    API_PATH.PointToken.getOwnedTokenHistoriesByOffsetPagination,
    async (req, res, ctx) => {
      const requestPageNumber =
        Number(req.url.searchParams.get('requestPageNumber')) || 1;
      await sleep(200);
      const limit = Number(req.url.searchParams.get('limit')) || 8;

      mockDB.point.pointInvoiceData.set({ limit });
      return res(
        ctx.status(200),
        ctx.json(mockDB.point.pointInvoiceData.get({ requestPageNumber })),
      );
    },
  );

export const getPointHistory = () =>
  createHandler(
    API_PATH.PointToken.findUserPointTokenHistories,
    async (req, res, ctx) => {
      const cursor = Number(req.url.searchParams.get('cursor'));
      const limit = Number(req.url.searchParams.get('limit'));

      await sleep(200);
      return res(
        ctx.status(200),
        ctx.json(mockDB.point.pointHistory.get({ limit, cursor })),
      );
    },
  );

export const dropPoint = () =>
  createHandler(API_PATH.PointToken.dropPointToken, async (req, res, ctx) => {
    await sleep(200);
    return res(ctx.status(200), ctx.json({ id: 'success' }));
  });

export default [
  getPointInvocies(),
  getPointInfo(),
  updatePointInfo(),
  getPointHistory(),
  dropPoint(),
];
